import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { StoreState } from '..'
import errorHandler from '../../errorHandler'
import { getScheduleItem } from '../../pages/dashboard/DashboardDetails'
import { getSchedule } from '../../pages/schedule/Schedule'
import apiRest from '../../services/apiRest'
import { getPeople } from '../people/peopleActions'
import {
  getResumeYear,
  getTransactions,
} from '../transactions/transactionsActions'
import { SessionAction, SessionActionTypes } from './sessionTypes'
import getPatrimony from '../patrimony/patrimonyActions'
import { getPayment } from '../payments/paymentActions'
import { getTransfers } from '../transfers/transfersActions'
import { getAlertsUser } from '../../store/alertsUser/alertsUserActions'

export function login(
  email: string,
  password: string
): ThunkAction<Promise<void>, any, undefined, SessionAction> {
  return async (dispatch) => {
    try {
      const data = {
        email: email.trim(),
        password: password.trim(),
      }
      dispatch({ type: SessionActionTypes.LOGIN_START })
      const res = await apiRest.post('/users/login/', data, {
        validateStatus: (status) => status < 500,
      })
      switch (res.status) {
        case 200:
          sessionStorage.setItem('birthday', 'yes')
          sessionStorage.token = res.data.token
          dispatch({
            type: SessionActionTypes.LOGIN_SUCCESS,
            user: res.data.user,
          })
          dispatch(getAlertsUser())

          break
        case 401:
          dispatch({
            type: SessionActionTypes.LOGIN_FAIL,
            failed: 'Senha incorreta',
          })
          break
        case 422:
          dispatch({
            type: SessionActionTypes.LOGIN_FAIL,
            failed: 'E-mail não cadastrado',
          })
          break
        default:
          throw new Error(JSON.stringify(res.data))
      }
    } catch (e) {
      errorHandler(e)
      dispatch({ type: SessionActionTypes.LOGIN_ERROR })
    }
  }
}

export function startSession(): ThunkAction<
  Promise<void>,
  any,
  undefined,
  SessionAction
> {
  return async (dispatch) => {
    try {
      if (!sessionStorage.token) {
        dispatch({ type: SessionActionTypes.SESSION_FAIL })
        return
      }
      dispatch({ type: SessionActionTypes.SESSION_START })
      const res = await apiRest.get('/users/from-auth/')
      dispatch({
        type: SessionActionTypes.SESSION_SUCCESS,
        user: res.data,
      })
    } catch (e) {
      errorHandler(e)
      sessionStorage.removeItem('token')
      dispatch({ type: SessionActionTypes.SESSION_FAIL })
    }
  }
}

export function logout(): ThunkAction<void, any, undefined, SessionAction> {
  return (dispatch) => {
    sessionStorage.removeItem('token')
    dispatch({ type: SessionActionTypes.LOGOUT })
  }
}

export function changeChurch(
  churchId: string
): ThunkAction<void, StoreState, undefined, Action> {
  return (dispatch, getState) => {
    const index = getState().sessionState.user?.churches.findIndex(
      (church: any) => church.id === churchId
    )
    const { pathname } = getState().router.location

    dispatch({
      type: SessionActionTypes.CHANGE_CHURCH,
      selectedChurchIndex: index,
    })
    switch (pathname) {
      case '/lancamentos':
        dispatch(getResumeYear())
        dispatch(getTransactions())
        break
      case '/membros':
        dispatch(getPeople())
        break
      case '/transferencias':
        dispatch(getTransfers())
        break
      case '/agenda':
        dispatch(getScheduleItem())
        dispatch(getSchedule())
        break
      case '/':
        dispatch(getScheduleItem())
        dispatch(getSchedule())
        dispatch(getPeople())
        break
      case '/birthday':
        dispatch(getPeople())
        break
      case '/patrimony':
        dispatch(getPatrimony())
        break
      case '/payment':
        dispatch(getPayment())
        break
    }
  }
}
